import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';
import { selectRewardTokens } from '../reward-tokens/selectors';
import { betslipTypeStateSelector } from '../types/selectors';

export const teaserBetStateSelector = createSelector(betslipTypeStateSelector, (state) => state.teaserBet);

export const teaserBetSelectedPointsSelector = createSelector(teaserBetStateSelector, (s) => s.selectedPoints);

export const teaserBetPicksSelector = createSelector(teaserBetStateSelector, (s) => s.picks);

export const teaserBetPickTeasersSelector = createSelector(betslipSelector, (state) => ({
    pickState: state.picks,
    teaserBetsState: state.types.teaserBet,
    currrentSelectedType: state.types.base.currentSelectedType,
}));

export const teaserBetStateStakeSelector = createSelector(teaserBetStateSelector, (teaserBet) => ({
    actualStake: teaserBet.actualStake,
    stake: teaserBet.stake,
}));

export const selectTeaserBetRewardTokenId = createSelector(teaserBetStateSelector, (state) => state.rewardTokenId);

export const selectTeaserBetRewardToken = createSelector(selectTeaserBetRewardTokenId, selectRewardTokens, (tokenId, tokens) => {
    return tokenId ? tokens[tokenId] : null;
});
